<template>
  <div>
    <MainForm
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      name="nbc-card-form"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      ui-title="NBC card application"
      :data-nbc-suggestions-visible="showFilters"
      :data-nbc-finished="hasNBCFinished"
    >
    
      <StepModel
        :ui="uiBaseStep"
        name="rewardstype-step"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
        ui-hide-button
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="rewardstype"
          ui-title="What kind of rewards would you like?"
        >
          <UiWrapper :name="FIELD_NAMES.rewards" next-step-on-change>
            <Choice :options="REWARDSTYPE" />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>

      <StepModel
        :ui="uiBaseStep"
        name="income-step"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
        ui-hide-button
        :custom-flow="[
          {
            condition: () => fieldValues(FIELD_NAMES.income) === 'Less than AED 10,000',
            goTo: 'show-cards',
          },
          {
            condition: () => fieldValues(FIELD_NAMES.income) === 'AED 10,000 - AED 25,000',
            goTo: 'use-step',
          },
          {
            condition: () => fieldValues(FIELD_NAMES.income) === 'More than AED 25,000',
            goTo: 'uselong-step',
          }
        ]"
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="income"
          ui-title="What is your fixed monthly income?"
        >
          <UiWrapper :name="FIELD_NAMES.income" next-step-on-change>
            <Choice :options="INCOME" :columns="3" />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>

      <StepModel
        :ui="uiBaseStep"
        name="use-step"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
        ui-hide-button
      >
        <FieldsetModel :ui="uiBaseFieldset" name="use" ui-title="What are you going to use it for?">
          <UiWrapper :after-change="finishNBC" :name="FIELD_NAMES.use">
            <Choice :options="CARD_USE" :columns="2" />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>

      <StepModel
        :ui="uiBaseStep"
        name="uselong-step"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
        ui-hide-button
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="uselong"
          ui-title="What are you going to use it for the most?"
        >
          <UiWrapper :after-change="finishNBC" :name="FIELD_NAMES.uselong">
            <Choice :options="CARD_USE_LONG" :columns="3" />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>

      <StepModel :ui="uiBaseStep" name="show-cards" ui-title=" " ui-subtitle=" " ui-hide-button>
        <FieldsetModel :ui="uiBaseFieldset" name="empty-show-cards" ui-title>
          <span />
        </FieldsetModel>
      </StepModel>
    </MainForm>

    <NBCSuggestions :show="showFilters">
      <template v-slot:header>
        <span v-html="dynamicRecommendation">{{ dynamicRecommendation }}</span>
      </template>
      <template v-slot:suggestions>
        <div v-for="(product, key) in getFilteredSuggestions" :key="key">
          <ProductCover
            :key="key"
            :image="product.image"
            :title="product.title"
            :label="showBest(key, product.best)"
            :features="product.features"
          >
            <template v-slot:btn-left v-if="canApply">
              <Button
                width="full"
                size="md"
                :click="actionWrapper(goToForm, product.onboarding_form,product.title)"
              >Apply</Button>
            </template>
          </ProductCover>
        </div>
      </template>
    </NBCSuggestions>

    <div v-for="(product, key) in getFilteredSuggestions" :key="key" class="side-panels">
      <SidePanel
        :legend="product.benefits.legend"
        :title="product.benefits.title"
        :show="isPanelVisible(key)"
        :on-close="() => { hidePanel() }"
      >
        <Grid>
          <div
            v-for="(item, itemKey) in product.benefits.items"
            :key="itemKey"
            class="grid-cell"
            data-width-xs="12"
            data-width-md="6"
          >
            <PlainText>
              <img :src="item.image" />
              <div class="regular-big" v-html="item.title" />
              <div class="regular-medium">{{ item.content }}</div>
            </PlainText>
          </div>
        </Grid>
      </SidePanel>
    </div>
  </div>
</template>

<script>
// Models
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import store from "@/store";
import StepOtp from "@/forms/components/shared/steps/otp";
import FIELD_NAMES from "@/forms/constants/field-names";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
import {
  SET_SPENDING,
  SET_SALARY_RECEIVE,
  SET_REWARD_TYPE,
  SET_CASH_BACK_POINT,
  SET_TEN_TO_TWENTY_FIVE,
  SET_MORE_THAN_TWENTY_FIVE,
  SET_LOAN_TYPE
} from "@/lib/constants/mutations";
// Services
import flowManager from "@/lib/services/flow-manager";

// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";

// Ui Components
import {
  NBCSuggestions,
  // InputText,
  Choice,
  Button,
  ProductCover,
  SidePanel,
  Grid,
  PlainText
} from "@dunia/ui";

// Utils
import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
// Helpers

// Constants
import {
  SPENDING,
  YESNO,
  INCOME,
  CARD_USE,
  CARD_USE_LONG,
  REWARDSTYPE,
  FEATURES_NBC_CARDS,
  //FIELD_NAMES
} from "@/forms/constants/nbc-aggregator-logic";

export default {
  name: "NBC",

  mixins: [FormComponentMixin],

  components: {
    NBCSuggestions,
    // Components
    MainForm,
    StepModel,
    FieldsetModel,
    // InputText,
    Choice,
    UiWrapper,
    Button,
    // Pages
    ProductCover,
    SidePanel,
    Grid,
    PlainText,
    StepOtp
  },

  data: () => ({
    panelVisible: -1,
    ___readyToAnimate: false,
    SPENDING,
    YESNO,
    INCOME,
    CARD_USE,
    CARD_USE_LONG,
    REWARDSTYPE,
    FEATURES_NBC_CARDS,
    FIELD_NAMES
  }),
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  updated: function() {
    store.commit(SET_SPENDING, {
      spending: this.fieldValues(FIELD_NAMES.spending)
    });
    store.commit(SET_SALARY_RECEIVE, {
      salaryReceive: this.fieldValues(FIELD_NAMES.salary)
    });
    store.commit(SET_REWARD_TYPE, {
      rewardType: this.fieldValues(FIELD_NAMES.rewards)
    });
    store.commit(SET_CASH_BACK_POINT, {
      cashBackPoint: this.fieldValues(FIELD_NAMES.income)
    });
    store.commit(SET_TEN_TO_TWENTY_FIVE, {
      tenToTwentyFive: this.fieldValues(FIELD_NAMES.use)
    });
    store.commit(SET_MORE_THAN_TWENTY_FIVE, {
      moreThanTwentyFive: this.fieldValues(FIELD_NAMES.uselong)
    });
  },
  computed: {
    // show if
    // - 1st answer is Paying straight, or
    // - 1st answer is Deferred and the 2nd is also answered
    showFilters() {
      const { values } = this.$store.state.formData;

      const spending = getValueByFieldName(values, FIELD_NAMES.spending);
      const rewards = getValueByFieldName(values, FIELD_NAMES.rewards);

      return (
        this.___readyToAnimate &&
        (spending === "Paying straight away" || rewards !== null)
      );
    },

    canApply() {
      const { values } = this.$store.state.formData;

      const spending = getValueByFieldName(values, FIELD_NAMES.spending);
      const income = getValueByFieldName(values, FIELD_NAMES.income);

      if (spending === "Paying straight away" || income !== null) {
        return true;
      }
      return false;
    },

    getFilteredSuggestions() {
      const { values } = this.$store.state.formData;

      const spending = getValueByFieldName(values, FIELD_NAMES.spending);
      const rewards = getValueByFieldName(values, FIELD_NAMES.rewards);
      const income = getValueByFieldName(values, FIELD_NAMES.income);
      const use = getValueByFieldName(values, FIELD_NAMES.use);
      const uselong = getValueByFieldName(values, FIELD_NAMES.uselong);

      return FEATURES_NBC_CARDS.filter((el, key) => {
        if (key === 0) {
          // stored value card
          return spending === "Paying straight away";
        }
        if (key === 1) {
          // world miles card
          if (
            (rewards === "Miles Up for travel rewards" && income === null) ||
            (rewards === "Miles Up for travel rewards" &&
              income === "More than AED 25,000" &&
              uselong === null) ||
            (rewards === "Miles Up for travel rewards" &&
              income === "More than AED 25,000" &&
              uselong === "Travel")
          ) {
            return true;
          }
        }
        if (key === 2) {
          // platinum miles card
          if (
            (rewards === "Miles Up for travel rewards" && income === null) ||
            (rewards === "Miles Up for travel rewards" &&
              income === "AED 10,000 - AED 25,000" &&
              use === null) ||
            (rewards === "Miles Up for travel rewards" &&
              income === "AED 10,000 - AED 25,000" &&
              use === "Shopping and Lifestyle") ||
            (rewards === "Miles Up for travel rewards" &&
              income === "More than AED 25,000" &&
              uselong === null) ||
            (rewards === "Miles Up for travel rewards" &&
              income === "More than AED 25,000" &&
              uselong === "Shopping and Lifestyle")
          ) {
            return true;
          }
        }
        if (key === 3) {
          // titanium miles card
          if (
            (rewards === "Miles Up for travel rewards" && income === null) ||
            (rewards === "Miles Up for travel rewards" &&
              income === "Less than AED 10,000") ||
            (rewards === "Miles Up for travel rewards" &&
              income === "AED 10,000 - AED 25,000" &&
              use === null) ||
            (rewards === "Miles Up for travel rewards" &&
              income === "AED 10,000 - AED 25,000" &&
              use === "Everyday spend") ||
            (rewards === "Miles Up for travel rewards" &&
              income === "More than AED 25,000" &&
              uselong === null) ||
            (rewards === "Miles Up for travel rewards" &&
              income === "More than AED 25,000" &&
              uselong === "Everyday spend")
          ) {
            return true;
          }
        }
        if (key === 4) {
          // world cashpoints card
          if (
            (rewards === "Cash Up for cashback" && income === null) ||
            (rewards === "Cash Up for cashback" &&
              income === "More than AED 25,000" &&
              uselong === null) ||
            (rewards === "Cash Up for cashback" &&
              income === "More than AED 25,000" &&
              uselong === "Travel")
          ) {
            return true;
          }
        }
        if (key === 5) {
          // platinum cashpoints card
          if (
            (rewards === "Cash Up for cashback" && income === null) ||
            (rewards === "Cash Up for cashback" &&
              income === "AED 10,000 - AED 25,000" &&
              use === null) ||
            (rewards === "Cash Up for cashback" &&
              income === "AED 10,000 - AED 25,000" &&
              use === "Shopping and Lifestyle") ||
            (rewards === "Cash Up for cashback" &&
              income === "More than AED 25,000" &&
              uselong === null) ||
            (rewards === "Cash Up for cashback" &&
              income === "More than AED 25,000" &&
              uselong === "Shopping and Lifestyle")
          ) {
            return true;
          }
        }
        if (key === 6) {
          // titanium cashpoints card
          if (
            (rewards === "Cash Up for cashback" && income === null) ||
            (rewards === "Cash Up for cashback" &&
              income === "Less than AED 10,000") ||
            (rewards === "Cash Up for cashback" &&
              income === "AED 10,000 - AED 25,000" &&
              use === null) ||
            (rewards === "Cash Up for cashback" &&
              income === "AED 10,000 - AED 25,000" &&
              use === "Everyday spend") ||
            (rewards === "Cash Up for cashback" &&
              income === "More than AED 25,000" &&
              uselong === null) ||
            (rewards === "Cash Up for cashback" &&
              income === "More than AED 25,000" &&
              uselong === "Everyday spend")
          ) {
            return true;
          }
        }

        return false;
      });
    },

    dynamicRecommendation() {
      const { values } = this.$store.state.formData;

      const spending = getValueByFieldName(values, FIELD_NAMES.spending);
      const salary = getValueByFieldName(values, FIELD_NAMES.salary);
      const rewards = getValueByFieldName(values, FIELD_NAMES.rewards);
      const income = getValueByFieldName(values, FIELD_NAMES.income);
      const use = getValueByFieldName(values, FIELD_NAMES.use);
      const uselong = getValueByFieldName(values, FIELD_NAMES.uselong);

      let r1 = "";
      let r2 = "";
      let r3 = "";
      let r4 = "";

      r1 = "A <strong>Credit card</strong>";

      if (rewards === "Miles Up for travel rewards") {
        r2 = " for <strong>Miles Up</strong>";
      }
      if (
        rewards === "Miles Up for travel rewards" &&
        income === "Less than AED 10,000"
      ) {
        r2 =
          " for <strong>Miles Up</strong>" +
          " and a <strong>salary less than AED 10K</strong>";
      }
      if (
        rewards === "Miles Up for travel rewards" &&
        income === "AED 10,000 - AED 25,000" &&
        use === "Shopping and Lifestyle"
      ) {
        r2 =
          " for <strong>Miles Up</strong>" +
          " and a <strong>salary between AED 10K - 25K</strong>" +
          " for <strong>shopping and lifestyle</strong>";
      }
      if (
        rewards === "Miles Up for travel rewards" &&
        income === "More than AED 25,000" &&
        uselong === "Shopping and Lifestyle"
      ) {
        r2 =
          " for <strong>Miles Up</strong>" +
          " and a <strong>salary of more than AED 25K</strong>" +
          " for <strong>shopping and lifestyle</strong>";
      }

      if (
        rewards === "Miles Up for travel rewards" &&
        income === "AED 10,000 - AED 25,000" &&
        use === "Everyday spend"
      ) {
        r2 =
          " for <strong>Miles Up</strong>" +
          " and a <strong>salary between AED 10K - 25K</strong>" +
          " for <strong>everyday spend</strong>";
      }
      if (
        rewards === "Miles Up for travel rewards" &&
        income === "More than AED 25,000" &&
        uselong === "Everyday spend"
      ) {
        r2 =
          " for <strong>Miles Up</strong>" +
          " and a <strong>salary of more than AED 25K</strong>" +
          " for <strong>everyday spend</strong>";
      }

      if (
        rewards === "Miles Up for travel rewards" &&
        income === "More than AED 25,000" &&
        uselong === "Travel"
      ) {
        r2 =
          " for <strong>Miles Up</strong>" +
          " and a <strong>salary of more than AED 25K</strong>" +
          " for <strong>travel</strong>";
      }
      ////casback
      if (rewards === "Cash Up for cashback") {
        r2 = " for <strong>Cash Up</strong>";
      }
      if (
        rewards === "Cash Up for cashback" &&
        income === "Less than AED 10,000"
      ) {
        r2 =
          " for <strong>Cash Up</strong>" +
          " and a <strong>salary less than AED 10K</strong>";
      }
      if (
        rewards === "Cash Up for cashback" &&
        income === "AED 10,000 - AED 25,000" &&
        use === "Shopping and Lifestyle"
      ) {
        r2 =
          " for <strong>Cash Up</strong>" +
          " and a <strong>salary between AED 10K - 25K</strong>" +
          " for <strong>shopping and lifestyle</strong>";
      }

      if (
        rewards === "Cash Up for cashback" &&
        income === "More than AED 25,000" &&
        uselong === "Shopping and Lifestyle"
      ) {
        r2 =
          " for <strong>Cash Up</strong>" +
          " and a <strong>salary of more than AED 25K</strong>" +
          " for <strong>shopping and lifestyle</strong>";
      }

      if (
        rewards === "Cash Up for cashback" &&
        income === "AED 10,000 - AED 25,000" &&
        use === "Everyday spend"
      ) {
        r2 =
          " for <strong>Cash Up</strong>" +
          " and a <strong>salary between AED 10K - 25K</strong>" +
          " for <strong>everyday spend</strong>";
      }

      if (
        rewards === "Cash Up for cashback" &&
        income === "More than AED 25,000" &&
        uselong === "Everyday spend"
      ) {
        r2 =
          " for <strong>Cash Up</strong>" +
          " and a <strong>salary of more than AED 25K</strong>" +
          " for <strong>everyday spend</strong>";
      }
      if (
        rewards === "Cash Up for cashback" &&
        income === "More than AED 25,000" &&
        uselong === "Travel"
      ) {
        r2 =
          " for <strong>Cash Up</strong>" +
          " and a <strong>salary of more than AED 25K</strong>" +
          " for <strong>travel</strong>";
      }

      return `${r1}${r2}`;
    },

    hasNBCFinished() {
      return flowManager.currentStepName === "show-cards";
    },
     isSalesAgent(){
       return this.$store.state.employeeCodes;
     },
  },

  methods: {
    finishNBC() {
      flowManager.goToNextStep({ stepToGo: "show-cards" });
    },

    actionWrapper(cb, ...args) {
      return () => cb(...args);
    },

    fieldValues(fieldname) {
      const { $store } = this;

      return getValueByFieldName($store.state.formData.values, fieldname);
    },

    // benefits panel logic
    isPanelVisible(key) {
      return key === this.panelVisible;
    },

    showPanel(key) {
      this.panelVisible = key;
    },

    hidePanel() {
      this.panelVisible = -1;
    },

    showBest(key, label) {
      if (key === 0) {
        return label;
      }
      return null;
    },
     gotToWelcome(callback) {
  var product = this.fieldValues(FIELD_NAMES.product);
        var formToGo = "Deem | Credit Card Application | Aggregator";
       
         callback();
        
          router.goToFormByName(formToGo, {
            stepNameToInit: stepToGo
          });
    },
  },
 
  mounted() {
    this.___readyToAnimate = true;
  }
};
</script>
